import { RectSize } from '../../../../common/maths/geometry/rect/rectTypes';

/**
 * Fit a size within bounds, preserving aspect ratio and never upscaling beyond the original size.
 */
export const fitSizeWithinBounds = (size: RectSize, bounds: RectSize): RectSize => {
    if (!size.width || !size.height || !bounds.width || !bounds.height) {
        return { width: 0, height: 0 };
    }

    const scale = Math.min(1, bounds.width / size.width, bounds.height / size.height);

    return {
        width: Math.min(bounds.width, size.width * scale),
        height: Math.min(bounds.height, size.height * scale),
    };
};
